import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from '..';

const selectSelf = (state: GlobalState) => state.bundle;

export const bundleSelector = createSelector(selectSelf, (state) => state.item);
